export default __webpack_public_path__ + "static/media/signin_popup.dcef226b.png";